// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner__item[data-v-7f1333fd]{flex-shrink:0;width:100%;height:100%}.banner__img[data-v-7f1333fd]{width:100%;height:100%;border-radius:.5rem}", ""]);
// Exports
module.exports = exports;
